module.exports = __webpack_public_path__ + "img/symbol_1.1ea4875d.png";